import { ArrowRight, SaveIcon } from "../../../../assets/svgIcons";
import primaryComponents from "../../../primaryComponents";
import { useValidation } from "./useValidation";
import { useStorefrontDetailsForm } from "./useStorefrontDetailsForm";
import { pathConstants } from "../../../../routes/pathContants";
import globalStyles from "../../../../assets/styles/base/globalPage.module.scss";
import secondaryComponents from "../..";
import { ProductList } from "./ProductList";

export const StorefrontDetailsForm = ({
  isEditMode = false,
  storefrontDetails = {},
  selectedStorefrontProduct = [],
}) => {
  const {
    formData,
    storeList,
    queryParams,
    isFetchingNextPage,
    isFetchingProduct,
    productList,
    isCreating,
    autoScrollRef,
    setFormData,
    handleStorefront,
    filterBySearch,
  } = useStorefrontDetailsForm({
    isEditMode,
    storefrontDetails,
    selectedStorefrontProduct,
  });
  const {
    handleSubmit,
    control,
    register,
    trigger,
    formState: { errors },
  } = useValidation({ ...formData });

  return (
    <>
      <div
        className={"d-flex flex-column flex-md-row"}
        style={{ columnGap: "50px", rowGap: "20px" }}
      >
        <primaryComponents.InputFieldV2
          control={control}
          name="name"
          value={formData?.name}
          classNames="white"
          label={"Storefront Name"}
          placeholder={"Enter storefront name"}
          onChange={({ target: { value } }) => {
            setFormData((prev) => ({ ...prev, name: value }));
          }}
          isRequired
          errorMessage={errors.name}
          onKeyUp={() => errors.name !== undefined && trigger("name")}
          register={register}
        />

        <div className="w-100">
          <primaryComponents.SelectFieldV2
            control={control}
            name="store"
            label={"Store"}
            placeholder={"Select store(s) to pick items from"}
            options={storeList}
            value={
              storeList?.find((item) => `${item.id}` === `${formData?.store}`)
                ?.name || "Select store"
            }
            isDisabled={isEditMode}
            idKey={"id"}
            nameKey={"name"}
            isRequired
            onChange={(value) => {
              setFormData((prev) => ({ ...prev, store: value }));
            }}
            errorMessage={errors.store}
          />
        </div>
      </div>

      <div>
        <h5>Select items to display on your storefront</h5>
        <p>
          Click the check box next to your product name to select an item or{" "}
          <span
            className="purple--text cursor-pointer"
            style={{ textDecoration: "underline" }}
            onClick={() =>
              window.open(pathConstants.INVENTORY_PRODUCTS_ADD_SINGLE, "_blank")
            }
          >
            Create a new product
          </span>
        </p>
      </div>

      <div className={`${globalStyles.tableWrapper}`}>
        <div className={`${globalStyles.tableHeader} align-items-center`}>
          <primaryComponents.SearchField
            classNames={`${globalStyles.searchField}`}
            placeholder="Search by product name, ID & SKU"
            trigger={(value) => filterBySearch(value)}
            value={queryParams?.query}
            triggerOnInput={true}
            showsearchBtn={true}
          />

          <h4 className="ml-auto">
            {Object?.keys(formData?.storefront_items)?.length} items selected
          </h4>
        </div>

        <secondaryComponents.LoaderHelper
          isLoading={isFetchingProduct}
          classNames={"mt-5"}
        >
          <ProductList
            productList={productList}
            autoScrollRef={autoScrollRef}
            formData={formData}
            setFormData={setFormData}
          />
        </secondaryComponents.LoaderHelper>

        <secondaryComponents.LoaderHelper
          classNames="mt-4"
          isLoading={isFetchingNextPage && !isFetchingProduct}
        ></secondaryComponents.LoaderHelper>
      </div>

      <div
        className="mt-auto ml-auto"
        style={{
          position: "sticky",
          bottom: 0,
          zIndex: 2,
          background: "white",
          width: "fit-content",
        }}
      >
        <primaryComponents.Button
          classNames={"btn btn--primary ml-auto"}
          isLoading={isCreating}
          isDisabled={isCreating}
          onClick={handleSubmit(handleStorefront)}
          style={{ width: "150px" }}
        >
          {!isEditMode ? (
            <>
              <ArrowRight style={{ fontSize: "25px" }} className="mr-1" />
              Next
            </>
          ) : (
            <>
              <SaveIcon style={{ fontSize: "25px" }} className="mr-1" />
              Save
            </>
          )}
        </primaryComponents.Button>
      </div>
    </>
  );
};
